import { render } from "./chooseTeam.vue?vue&type=template&id=35bd5536&scoped=true&ts=true"
import script from "./chooseTeam.vue?vue&type=script&lang=ts"
export * from "./chooseTeam.vue?vue&type=script&lang=ts"

import "./chooseTeam.vue?vue&type=style&index=0&id=35bd5536&lang=less&scoped=true"

import exportComponent from "/root/djmesweb-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35bd5536"]])

export default __exports__